import type { Messages } from './en';

/** Textos de la caça del tresor. Les endevinalles es queden en anglès (vegeu content/treasure.ts). */
export const caTreasure: Pick<Messages, 'treasure'> = {
  treasure: {
    title: '🏴‍☠️ Caça del tresor',
    intro: 'Avui hi ha tres tresors amagats. Llegeix les pistes en anglès, segueix la brúixola i cava quan digui “Just aquí, cava!”.',
    clue: (n: number) => `Pista ${n}`,
    listen: '🔊 Escoltar',
    translate: '🌐 Ajuda en la meva llengua',
    follow: '🧭 Seguir aquesta pista',
    following: '🧭 Seguint',
    done: '✅ Trobat!',
    heat: ['🧊 Fred', '🌤️ Tebi', '☀️ Calentet', '🔥 Calent!', '⛏️ Just aquí, cava!'],
    otherMap: '🧭 Aquí no és; prova en un altre lloc',
    dig: '⛏️ Cavar aquí',
    found: 'Has trobat un cofre del tresor!',
    foundItem: (icon: string, name: string) => `Tresor! Has trobat: ${icon} ${name}`,
    allFound: '🏆 Has trobat tots els tresors d’avui! Premi +10⭐ +30🪙',
    albumTitle: 'Àlbum de tresors',
    album: {
      coin: 'Moneda antiga', marble: 'Bala de vidre', shell: 'Petxina en espiral', robot: 'Robot de llauna', postcard: 'Postal antiga', charm: 'Amulet de la sort',
      compass: 'Brúixola de llautó', feather: 'Ploma daurada', stamp: 'Segell rar', crystal: 'Cristall blau', whistle: 'Xiulet de plata', medal: 'Medalla d’heroi',
    },
    hints: {
      fountain: 'A prop de la font (del poble o del centre comercial).',
      pond: 'A la vora de l’estany del parc.',
      cherry: 'Sota un cirerer del pati de l’escola.',
      busStop: 'Al costat de la parada de l’autobús del carrer principal.',
      slide: 'Al costat del tobogan del parc infantil.',
      hay: 'Al costat de la palla de les cuadres.',
      tennis: 'En un racó de la pista de tennis.',
      track: 'En un racó de la pista d’atletisme.',
      mailbox: 'Al costat de la bústia vermella de davant de casa teva.',
      kiteTree: 'Sota l’arbre gros del barri.',
      library: 'A la biblioteca, a prop de la taula de lectura.',
      piano: 'A l’aula de música, al costat del piano.',
      easel: 'A l’aula de plàstica, a prop del cavallet.',
      pool: 'A la piscina, a prop de la cadira del socorrista.',
      store: 'Dins la botiga de la cantonada, entre les prestatgeries.',
      sofa: 'A casa, a prop del sofà de la sala d’estar.',
    },
  },
};
